export default __webpack_public_path__ + "static/media/1955.764f66b9.png";